import { isArray, isEmpty, isObject, isNumber, has } from "lodash";
export const generateId = (length = 10) => {
  let id = "";
  const possible = "0123456789";

  for (let i = 0; i < length; i++) {
    id += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return id;
};

export const getElementHeight = (selector) => {
  return document.querySelector(selector).scrollHeight;
};

export const shuffleArray = (array) => {
  const arrayCopy = [...array];
  let length = arrayCopy.length;
  let temp;
  let idx;

  // While there remain elements to shuffle…
  while (length) {
    // Pick a remaining element…
    idx = Math.floor(Math.random() * length--);

    // And swap it with the current element.
    temp = arrayCopy[length];
    arrayCopy[length] = arrayCopy[idx];
    arrayCopy[idx] = temp;
  }

  return arrayCopy;
};

export const topMenuFormatter = (data) => {
  const storeMenu = JSON.parse(JSON.stringify(data));
  storeMenu.sort((a, b) => a.parent_id - b.parent_id);

  let menu = storeMenu.filter((item) => !item.parent_id);

  menu = menu.map((el, idx) => {
    const children = storeMenu.filter((item) => item.parent_id === el.id);

    const colmns = [];
    children.forEach((child) => {
      if (child.is_title) {
        colmns.push({
          title: child,
          list: [],
        });
      } else {
        if (!colmns.length || !colmns.some((co) => !co.title)) {
          colmns.push({
            list: [],
          });
        }
        colmns.forEach((col) => {
          if (!col.title) {
            col.list.push(child);
          }
        });
      }
    });

    colmns.forEach((col) => {
      const secChildren = storeMenu.filter(
        (item) => col.title && col.title.id === item.parent_id
      );
      if (secChildren && secChildren.length) {
        col.list = secChildren;
      }
    });
    return {
      ...el,
      isOpen: false,
      columns: colmns,
    };
  });
  return menu;
};

export const linkBuilder = (link) => {
  if (!link) {
    return "";
  }
  return `${process.env.IMAGE_URL}${link}`;
};

export const DataURIToBlob = (dataURI) => {
  const splitDataURI = dataURI.split(",");
  const byteString =
    splitDataURI[0].indexOf("base64") >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], { type: mimeString });
};

export const debounce = (func, wait, immediate) => {
  let timeout;

  return function executedFunction() {
    const context = this;
    const args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};

export const productQueryBuilder = (item) => {
  let string = `?config=${item.sku}`;
  if (
    typeof item.engraving === "object" &&
    !Array.isArray(item.engraving) &&
    item.engraving !== null
  ) {
    Object.entries(item.engraving).forEach(([key, val], idx) => {
      string = string + `&${key}=${val}`;
    });
  }

  return string;
};

export function parseJson(code) {
  try {
    return JSON.parse(code);
  } catch (e) {
    return null;
  }
}

export function getImageByPosition(list, position) {
  return list?.find((el) => el.position === position);
}

export function objectToQuery(object) {
  return Object.entries(object).reduce((acc, [key, value]) => {
    if (isArray(value) && !isEmpty(value)) {
      acc[`${key}[]`] = value;
    } else if (!isArray(value)) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export function mergeObjects(obj1, obj2) {
  const mergedObj = JSON.parse(JSON.stringify(obj1));
  for (const key in obj2) {
    if (has(obj2, key)) {
      if (isEmpty(obj1[key]) && !isNumber(obj1[key])) {
        mergedObj[key] = obj2[key];
      } else if (
        typeof mergedObj[key] === "object" &&
        typeof obj2[key] === "object"
      ) {
        mergedObj[key] = mergeObjects(mergedObj[key], obj2[key]);
      }
    }
  }
  return mergedObj;
}

export function addCurrentTranslation(
  data,
  translationId,
  defaultTranslationId
) {
  if (Array.isArray(data)) {
    return data.map((item) =>
      addCurrentTranslation(item, translationId, defaultTranslationId)
    );
  } else if (isObject(data)) {
    const newData = { ...data };

    if (Array.isArray(newData.translations)) {
      const currentTranslation = newData.translations.find(
        (translation) => translation.language_id === translationId
      );
      const defaultTranslation = newData.translations.find(
        (translation) => translation.language_id === defaultTranslationId
      );

      newData.currentTranslation = currentTranslation;

      newData.mixedTranslation = mergeObjects(
        currentTranslation || {},
        defaultTranslation || {}
      );
    }

    for (const key in newData) {
      if (has(newData, key)) {
        newData[key] = addCurrentTranslation(
          newData[key],
          translationId,
          defaultTranslationId
        );
      }
    }

    return newData;
  }
  return data;
}

/**
 * Checks if provided date is equal to today's date.
 *
 * @param {Date} date - The date to be compared with today's date.
 * @returns {boolean} Returns `true` if provided date is today's date, `false` otherwise.
 */
export function isToday(date) {
  const today = new Date();

  return today.toDateString() === date.toDateString();
}

/**
 * Get random item from array.
 *
 * @param {array} items - Array of items.
 * @returns {*} Returns random item from array
 */
export function getRandomArrayItem(items) {
  if (items?.length) {
    return items[Math.floor(Math.random() * items.length)];
  }
}

export function getRedirectUrl(
  path,
  availableLocales,
  queryParams = {},
  domain
) {
  const domainURL = new URL(domain);

  const url = new URL(path, domain);

  if (domainURL.pathname?.length > 1) {
    url.pathname = domainURL.pathname + url.pathname;
  }

  // Remove the locale path prefix if it exists
  const segments = url.pathname.split("/");
  if (availableLocales.includes(segments[1])) {
    segments.splice(1, 1);
    url.pathname = segments.join("/");
  }

  // Add or replace query parameters
  Object.keys(queryParams).forEach((key) =>
    url.searchParams.set(key, queryParams[key])
  );

  // Remove dummy origin and return the result
  return url.toString();
}

export function setAttributeToElements(identifier, attribute, attributeValue) {
  const linkEls = window.document.querySelectorAll(identifier);
  linkEls.forEach((el) => {
    el.setAttribute(attribute, attributeValue);
  });
}

export function removeHTMLTagFromString(str) {
  return str ? str.replace(/<[^>]*>/g, " ") : "";
}

/** Replace placeholder with value
 * @param {string} value
 * @param {function} callback
 * */
export function replacePlaceholder(value, callback) {
  return value.replace(/\{([^}]+)\}/g, (match, variable) => {
    return callback(variable) || match;
  });
}

/**
 * Set custom property
 * @param {string} property
 * @param {string|number} value
 */
export function setCustomProperty(property, value) {
  if (!property) return;
  document?.documentElement?.style?.setProperty(property, value.toString());
}

/**
 *  Array to tree
 * @param {*[]} list
 * @returns {*[]}
 */
export function toTree(list) {
  const arr = parseJson(JSON.stringify(list)) || [];
  const arrMap = new Map(arr.map((item) => [item.id, item]));
  const tree = [];

  arr.forEach((item) => {
    if (item.parent_id) {
      const parentItem = arrMap.get(item.parent_id);

      if (parentItem) {
        if (parentItem.children) {
          parentItem.children.push(item);
        } else {
          parentItem.children = [item];
        }
      }
    } else {
      tree.push(item);
    }
  });

  return tree;
}

/**
 * Normalizes an address object by picking specific fields and replacing
 * any falsy value with an empty string.
 *
 * @param {Object} address - The address object to normalize.
 * @param {string} [address.company_name] - The company name.
 * @param {string} [address.person_first_name] - The first name of the person.
 * @param {string} [address.person_last_name] - The last name of the person.
 * @param {string} [address.email_address] - The email address.
 * @param {string} [address.phone_number] - The phone number.
 * @param {string} [address.address_line_1] - The first line of the address.
 * @param {string} [address.city] - The city.
 * @param {string} [address.zip] - The zip code.
 * @param {string} [address.country] - The country.
 * @param {string} [address.state] - The state.
 * @returns {Object} The normalized address object with all specified fields.
 */
export function normalizeAddress(address) {
  const keys = [
    "company_name",
    "person_first_name",
    "person_last_name",
    "email_address",
    "phone_number",
    "address_line_1",
    "city",
    "zip",
    "country",
    "state",
  ];

  return keys.reduce((acc, key) => {
    acc[key] = address[key] || "";
    return acc;
  }, {});
}

/**
 * Normalizes an array of link objects by removing trailing slashes from the `href` property of each link.
 *
 * @param {Object[]} links - An array of link objects to normalize.
 * @param {string} links[].hid - A unique identifier for the link (e.g., for SEO purposes).
 * @param {string} links[].rel - The relationship between the current document and the linked document (e.g., "alternate", "canonical").
 * @param {string} links[].href - The URL of the linked document. This property will be processed to remove the trailing slash.
 * @param {string} [links[].hreflang] - Optional. Specifies the language of the linked document (e.g., "en", "sk", "cs").
 * @returns {Object[]} - A new array of link objects where the `href` property of each object is normalized (trailing slashes removed).
 *
 * @example
 * const links = [
 *   {
 *     hid: "i18n-alt-sk",
 *     rel: "alternate",
 *     href: "https://example.com/path/",
 *     hreflang: "sk"
 *   },
 *   {
 *     hid: "i18n-can",
 *     rel: "canonical",
 *     href: "https://example.com/"
 *   }
 * ];
 *
 * const normalizedLinks = normalizeI18nLinks(links);
 * console.log(normalizedLinks);
 * // Output:
 * // [
 * //   { hid: "i18n-alt-sk", rel: "alternate", href: "https://example.com/path", hreflang: "sk" },
 * //   { hid: "i18n-can", rel: "canonical", href: "https://example.com" }
 * // ]
 */
export function normalizeI18nLinks(links = []) {
  if (!Array.isArray(links)) {
    return [];
  }
  return links.map((link) => {
    return {
      ...link,
      href: link.href.replace(/\/$/, ""),
    };
  });
}

/**
 * Build affiliate params from route query
 * @param {Object} query - Route query object
 * @returns {Object|undefined} Affiliate params or undefined
 */
export function buildAffiliateParams(query) {
  const isAwinSource = (value) => value === "awin" || value === "aw";
  const isAwin = isAwinSource(query?.utm_source) || isAwinSource(query?.source);

  if (!isAwin || !query?.awc) {
    return;
  }

  const params = {
    utm_source: query.utm_source,
    source: query.source,
    awc: query.awc,
    sv_campaign_id: query.sv_campaign_id,
    sv1: query.sv1,
    sn: query.sn,
  };

  return Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v)
  );
}

export function addScripts(str, to, pos) {
  // Create an element outside the document to parse the string with
  const div = document.createElement("div");

  const target = typeof to === "string" ? document[to] : to;

  // Parse the string
  div.innerHTML = str;

  // Copy those nodes to the real `head`, duplicating script elements so
  // they get processed
  let node = div.firstChild;
  while (node) {
    const next = node.nextSibling;
    if (node.tagName === "SCRIPT") {
      // Just appending this element wouldn't run it, we have to make a fresh copy
      const newNode = document.createElement("script");
      [...node.attributes].forEach((attr) => {
        newNode.setAttribute(attr.nodeName, attr.nodeValue || "");
      });
      while (node.firstChild) {
        // Note we have to clone these nodes
        newNode.appendChild(node.firstChild.cloneNode(true));
        node.removeChild(node.firstChild);
      }
      node = newNode;
    }
    if (pos === "start") {
      target.prepend(node.cloneNode(true));
    } else {
      target.append(node.cloneNode(true));
    }

    node = next;
  }
}

export function extractDataFromScriptTags(htmlString) {
  // Create a new DOMParser
  const parser = new DOMParser();
  // Parse the HTML string
  const doc = parser.parseFromString(htmlString, "text/html");
  // Select all script elements
  const scriptElements = doc.querySelectorAll("script");
  const scriptStrings = Array.from(scriptElements).reduce((acc, script) => {
    acc.push(script.outerHTML);
    return acc;
  }, []);
  return scriptStrings;
}

/**
 * Normalizes page number from route query parameter.
 * Returns valid page number (minimum 1) or default value if provided.
 * Handles cases when query.page is undefined, null, NaN, or invalid string.
 *
 * @param {string|number|undefined|null} pageQuery - Page value from route query
 * @param {number} [defaultPage=1] - Default page number to return if query value is invalid
 * @returns {number} Valid page number (minimum 1)
 *
 * @example
 * getPageFromQuery("2") // returns 2
 * getPageFromQuery("abc") // returns 1
 * getPageFromQuery(undefined) // returns 1
 * getPageFromQuery("5", 1) // returns 5
 * getPageFromQuery(null, 10) // returns 10
 */
export function getPageFromQuery(pageQuery, defaultPage = 1) {
  const page = Number(pageQuery);
  return (page && page > 0 && isFinite(page)) ? page : defaultPage;
}